import { render, staticRenderFns } from "./ConfirmLogoutCustomer.vue?vue&type=template&id=28e7b602&scoped=true"
import script from "./ConfirmLogoutCustomer.vue?vue&type=script&lang=js"
export * from "./ConfirmLogoutCustomer.vue?vue&type=script&lang=js"
import style0 from "./ConfirmLogoutCustomer.vue?vue&type=style&index=0&id=28e7b602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e7b602",
  null
  
)

export default component.exports